import React from 'react';
import GridContainer from '@jumbo/components/GridContainer';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TablaUsuarios from './Tabla';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.fiscalizacion.ejemplo'} />, isActive: true },
];

const MantenedorUsuarios = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.fiscalizacion.ejemplo" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          {/* <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.samplePage.description" />
          </div> */}
          <Divider />
          <div style={{ marginTop: 0 }}>
            <TablaUsuarios
              list={[
                { a: '1', b: 2 },
                { a: 3, b: '4' },
              ]}
            />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default MantenedorUsuarios;
